import React from "react";
import { Form, Input, Button, Row, Col, Select, Checkbox } from "antd";

import styles from "./userSearchForm.scss";
import { EntityType } from "../../../models";

const UserSearchForm = ({ onSubmit, form, onCreateMember }) => {
  const handleSubmit = e => {
    e.preventDefault();

    const data = form.getFieldsValue();
    if (data.email) {
      data.email = encodeURIComponent(data.email);
    }

    onSubmit(data);
  };

  const handleReset = () => {
    form.resetFields();
    onSubmit({});
  };

  return (
    <Row gutter={2} className={styles.form}>
      <Form
        layout="horizontal"
        onSubmit={handleSubmit}
      >
        <Col md={12} sm={24} lg={4} xl={4}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("id")(
              <Input placeholder={"ID"} />
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("username")(
              <Input placeholder={"Korisničko ime"} />
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("firstName")(
              <Input placeholder={"Ime"} />
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("lastName")(
              <Input placeholder={"Prezime"} />
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("identityNumber")(
              <Input placeholder={"OIB"} />
            )}
          </Form.Item>
        </Col>
        <Col md={24} sm={24} lg={4} xl={4}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("email")(
              <Input placeholder={"E-mail adresa"} />
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={4} xl={4}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("phoneNumber")(
              <Input placeholder={"Broj telefona"} />
            )}
          </Form.Item>
        </Col>
        <Col md={24} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("legalEntity")(
              <Select placeholder={"Tip prodavača"}>
                <Select.Option value={null} key={0}>
                  {"Tip prodavača"}
                </Select.Option>
                <Select.Option value={'false'} key={1}>
                  {"Fizička osoba"}
                </Select.Option>
                <Select.Option value={'true'} key={2}>
                  {"Pravna osoba"}
                </Select.Option>
               </Select>

            )}
          </Form.Item>
        </Col>
        <Col md={24} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("hasAutomaticAdRenewal")(
              <Select
                placeholder={"Aktivne usluge"}
                className={styles.moduleDropdown}
              >
                 <Select.Option value={null} key={0}>
                 {"Aktivne usluge"}
                </Select.Option>
                <Select.Option value={'true'} key={1}>
                  {"Aktivna obnova oglasa"}
                </Select.Option>
          
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col md={12} sm={24} lg={2} xl={2}>
          <Form.Item className={styles.gutterBox}>
            <Button type="primary" htmlType="submit" className={styles.userSearchFormActionButton}>
              {"Traži"}
            </Button>
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={2} xl={2}>
          <Form.Item className={styles.gutterBox}>
            <Button onClick={handleReset} className={styles.userSearchFormActionButton}>
              {"Resetiraj"}
            </Button>
          </Form.Item>
        </Col>
        {onCreateMember && (
          <Col md={12} sm={24} lg={3} xl={3}>
            <Form.Item className={styles.gutterBox}>
              <Button type="danger" onClick={onCreateMember} className={styles.userSearchFormActionButton}>
                {"Kreiraj korisnika"}
              </Button>
            </Form.Item>
          </Col>
        )}
      </Form>
    </Row >
  );
};

UserSearchForm.defaultProps = {
  className: ""
};

export default Form.create()(UserSearchForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/UserSearchForm/UserSearchForm.tsx